/** Custom blockquote block for BlockNote — renders as border-left styled quote */

import { createReactBlockSpec } from '@blocknote/react'
import { defaultProps } from '@blocknote/core'

export const Blockquote = createReactBlockSpec(
  {
    type: 'blockquote' as const,
    propSchema: { ...defaultProps },
    content: 'inline',
  },
  {
    render: ({ contentRef }) => (
      <blockquote
        ref={contentRef}
        style={{
          borderLeft: '3px solid var(--bn-colors-hovered, #d1d5db)',
          paddingLeft: '1rem',
          margin: '0.5rem 0',
          fontStyle: 'italic',
          opacity: 0.85,
        }}
      />
    ),
  },
)
